<header>
  <div class="headerSwatches">
    <span class="color1">. </span>
    <span class="color2">.</span>
    <span class="color3">.</span>
    <span class="color4">.</span>
    <span class="color5">.</span>
    <span class="color6">.</span>
    <span class="color7">.</span>
    <span class="color8">.</span>
    <span class="color9">.</span>
  </div>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
    <div class="container">
      <a class="navbar-brand" href="/"><img src="logo-patempo.png" height="39" alt="" /></a>
      <p class="navbar-brand-desciption">Patent Pendency</p>
      <button class="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"
           [ngClass]="{ show: isExpanded }">

        <ul class="navbar-nav flex-grow">

          <li class="nav-item me-2" [routerLinkActive]="['link-active']">
            <a *ngIf="isSteps else notSteps" class="nav-link text-dark hightligthed" [routerLink]="['/config/edit-step']">Steps</a>
            <ng-template #notSteps>
              <a class="nav-link text-dark" [routerLink]="['/config/edit-step']">Steps</a>
            </ng-template>
          </li>

          <li class="nav-item me-2" [routerLinkActive]="['link-active']">
            <a *ngIf="isSettings else notSettings" class="nav-link text-dark hightligthed" [routerLink]="['/config/edit-map']">Settings</a>
            <ng-template #notSettings>
              <a class="nav-link text-dark" [routerLink]="['/config/edit-map']">Settings</a>
            </ng-template>
          </li>

          <li class="nav-item me-2" [routerLinkActive]="['link-active']">
            <a *ngIf="isCountries else notCountries" class="nav-link text-dark hightligthed" [routerLink]="['/config/edit-country']">Countries</a>
            <ng-template #notCountries>
              <a class="nav-link text-dark" [routerLink]="['/config/edit-country']">Countries</a>
            </ng-template>
          </li>


          <li class="nav-item me-2" [routerLinkActive]="['link-active']">
            <a *ngIf="isProtection else notProtection" class="nav-link text-dark hightligthed" [routerLink]="['/config/edit-protection-type']">Protection Types</a>
            <ng-template #notProtection>
              <a class="nav-link text-dark" [routerLink]="['/config/edit-protection-type']">Protection Types</a>
            </ng-template>
          </li>


          <li class="nav-item me-2" [routerLinkActive]="['link-active']">
            <a *ngIf="isFilingRoutes else notFilingRoutes" class="nav-link text-dark hightligthed" [routerLink]="['/config/edit-filing-route']">Filing Routes</a>
            <ng-template #notFilingRoutes>
              <a class="nav-link text-dark" [routerLink]="['/config/edit-filing-route']">Filing Routes</a>
            </ng-template>
          </li>

          <li class="nav-item me-2" [routerLinkActive]="['link-active']">
            <a *ngIf="isTechFields else notTechFields" class="nav-link text-dark hightligthed" [routerLink]="['/config/edit-technical-field']">Technical Fields</a>
            <ng-template #notTechFields>
              <a class="nav-link text-dark" [routerLink]="['/config/edit-technical-field']">Technical Fields</a>
            </ng-template>
          </li>

          <li class="nav-item me-2" [routerLinkActive]="['link-active']">
            <a *ngIf="isUserInputs else notUserInputs" class="nav-link text-dark hightligthed" [routerLink]="['/config/edit-user-input']">User Inputs</a>
            <ng-template #notUserInputs>
              <a class="nav-link text-dark" [routerLink]="['/config/edit-user-input']">User Inputs</a>
            </ng-template>
          </li>

          <li class="nav-item dropdown">
            <a *ngIf="isEditUser else notEditUser" class="nav-link dropdown-toggle hightligthed" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ userFullName }}
            </a>
            <ng-template #notEditUser>
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ userFullName }}
              </a>
            </ng-template>

            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <button class="dropdown-item" (click)="updateUserProfile()">Update Profile</button>
              <button class="dropdown-item" (click)="updateUserPassword()">Update Password</button>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" [routerLink]="['/config/edit-user']">Users</a>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" (click)="logout()">Logout</button>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </nav>
</header>
